import { Fragment, useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Detail from '../../../components/groups/form';
import { CommonGroupCrumbs } from '../constants';
import { Group } from 'shell/models/group';
import { HttpResponse } from 'shell/models/http-response';
import { GroupForm } from 'system/components/groups/form';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { FunctionalityVM } from 'system/view-models/functionality';

const GroupEditPage = (): React.ReactElement => {
  const params = useParams();

  const { put: updateGroup } = useHttpFetch(`${__MANAGEMENT_API_URL__}/gruppi/${params.id}`);

  const navigate = useNavigate();

  const {
    data,
    get: getGroup,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Group>>(`${__MANAGEMENT_API_URL__}/gruppi/${params.id}`);

  const groupInitialValue: GroupForm = useMemo(() => {
    const group = data?.payload;
    if (!group || !!error) {
      return {
        name: '',
        code: '',
        lastUpdate: '',
        functionality: [],
      };
    }
    return {
      name: group.nome,
      code: group.key?.codice.toString() || '',
      lastUpdate: group.note,
      functionality: group.funzioni?.map((funzione) => ({
        id: funzione.key.codice.toString(),
        description: funzione.nome,
        institutionCode: funzione.codiceEnte,
        entity: funzione.entita,
        event: funzione.evento,
      })) as Array<FunctionalityVM>,
    };
  }, [data, error]);

  const onSubmit = useCallback(
    (formValues: GroupForm | undefined) => {
      updateGroup({
        nome: formValues?.name,
        note: formValues?.lastUpdate,
        funzioni: formValues?.functionality?.map((operation) => ({
          key: {
            codice: operation.id,
          },
          codiceEnte: operation.institutionCode,
          entita: operation.entity,
          evento: operation.event,
          nome: operation.description,
        })),
        key: {
          codice: formValues?.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/gruppi');
      });
    },
    [updateGroup, navigate]
  );

  useEffect(() => {
    getGroup();
  }, []);

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonGroupCrumbs, { name: 'Modifica Gruppo' }]} />
      {loading || !data || error ? null : (
        <Detail
          title="Modifica Gruppo"
          onOk={onSubmit}
          insert
          initialValues={groupInitialValue}
          onCancel={() => {
            navigate('/sistema/gruppi');
          }}
          isEdit
        />
      )}
    </Fragment>
  );
};

GroupEditPage.displayName = 'Group Edit page component';

export default GroupEditPage;
